import { Link } from 'react-router-dom'
import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'
import { SubscribeCta } from '@/components/website/SubscribeCta'
import { doctors } from '@/data/doctors'

function DoctorCard({ doctor }: { doctor: (typeof doctors)[number] }) {
  return (
    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
      <div className="doctor-items">
        <div className="doctor-image">
          <Link to={`/doctors/${doctor.slug}`}>
            <figure className="image-anime">
              <img src={doctor.image} alt={doctor.name} />
            </figure>
          </Link>
          <div className="doctor-share">
            <ul className="social-icon social-vertical">
              <li>
                <a href="#" aria-label="instagram">
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#" aria-label="facebook">
                  <i className="fa-brands fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#" aria-label="twitter">
                  <i className="fa-brands fa-x-twitter"></i>
                </a>
              </li>
            </ul>
            <div className="doctor-share-icon">
              <i className="fa-solid fa-share-nodes"></i>
            </div>
          </div>
          <div className="doctor-review">
            <p>
              <i className="fas fa-star active"></i> {doctor.rating}
            </p>
          </div>
        </div>
        <div className="doctor-content">
          <h3>
            <Link to={`/doctors/${doctor.slug}`}>{doctor.name}</Link>
          </h3>
          <p>{doctor.specialty}</p>
        </div>
      </div>
    </div>
  )
}

export function Doctors() {
  return (
    <>
      <PageBreadcrumb title="Doctor" />

      <section className="doctor-section-3 pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area">
                <div className="section-title">
                  <span className="sub-title">Our Doctors</span>
                  <h2>Meet Our Experienced Specialists</h2>
                </div>
                <div className="section-title-content">
                  <p>
                    Our team of qualified doctors and consultants covers cardiology, neurology, orthopedics,
                    pediatrics, general medicine, dermatology, emergency care and gynecology. Every patient at
                    Fast Aid Hospital receives careful examination, clear advice and compassionate care.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {doctors.map((doctor) => (
              <DoctorCard doctor={doctor} key={doctor.slug} />
            ))}
          </div>
        </div>
      </section>

      <SubscribeCta sectionClassName="background-one" />
    </>
  )
}
